<template>
  <div ref="quizTile" class="quiz-tile h-100 d-flex flex-column light">
    <Survey :fillout-id="data.filloutId" :student-uuid="studentUuid" :lesson-uuid="lessonUuid" :survey-name="data.name"
      @submit="onQuizSubmit" />

    <div v-if="!admin && submitted" class="quiz-buttons">
      <CircleButton icon-class="quiz-button" alt="Hide quiz" fa-icon="xmark" @click="onHideClick" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import Survey from '@/components/classroom/Survey.vue';
import CircleButton from "@/components/buttons/CircleButton.vue";

const emit = defineEmits(['quizSubmit', 'hideClick']);

const quizTile = ref(null);
const submitted = ref(false);

const props = defineProps({
  admin: Boolean,
  data: Object,
  studentUuid: String,
  lessonUuid: String,
});

function onQuizSubmit() {
  emit('quizSubmit', props.data.filloutId);
  submitted.value = true;
}

function onHideClick() {
  emit('hideClick');
}

</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.quiz-tile {
  margin-right: 2vh;
  flex-grow: 10;
  background-color: white;
  position: relative;
}

.quiz-buttons {
  margin: 1rem 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  color: black;
}

:deep {
  .quiz-button {
    border: 1px solid black;
  }
}
</style>
